import { fetchData, APIMethod, ACCESS_DOMAINS } from "@client";

export async function fetchProjectIssueTypesQuery(projectId) {
  return await fetchData(`api/get-project-issue-types/${projectId}`, APIMethod.GET, {
    baseURL: ACCESS_DOMAINS.btApi,
  });
}